import React, { useEffect, useContext } from "react";
import { useHistory, Link, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Modal from "@material-ui/core/Modal";

import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import CancelIcon from "@material-ui/icons/Cancel";

import { Context as HistoryContext } from "../context/history.context.js";
import { Context as AuthContext } from "../context/auth.context.js";
import { Context as PortalContext } from "../context/portal.context.js";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import MyTableRow from "../components/TableRowHistory";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { state } = useContext(PortalContext);
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  


  const headCells = () => {
    let invoicesPaidLabel = (state.dealerMerchant) ? "Deal Id" : "Invoices Paid";

    if (state.invoice_interface === "amount") {
      return [
        {
          id: "id",
          numeric: false,
          disablePadding: false,
          label: "Payment Id",
        },
        {
          id: "status",
          numeric: false,
          disablePadding: false,
          label: "Status",
        },
        {
          id: "paymentDate",
          numeric: false,
          disablePadding: false,
          label: "Date Paid",
        },
        {
          id: "invoicesPaid",
          numeric: false,
          disablePadding: false,
          label: invoicesPaidLabel,
        },
        {
          id: "amount",
          numeric: false,
          disablePadding: false,
          label: "Amount ($)",
        },
        {
          id: "paymentMethod",
          numeric: false,
          disablePadding: false,
          label: "Payment Method",
        },
      ];
    } else {
      return [
        {
          id: "id",
          numeric: false,
          disablePadding: false,
          label: "Payment Id",
        },
        {
          id: "status",
          numeric: false,
          disablePadding: false,
          label: "Status",
        },
        {
          id: "paymentDate",
          numeric: false,
          disablePadding: false,
          label: "Date Paid",
        },
        {
          id: "invoicesPaid",
          numeric: false,
          disablePadding: false,
          label: invoicesPaidLabel,
        },
        {
          id: "amount",
          numeric: false,
          disablePadding: false,
          label: "Amount ($)",
        },
        {
          id: "feeAmount",
          numeric: false,
          disablePadding: false,
          label: "Fee ($)",
        },
        {
          id: "paymentMethod",
          numeric: false,
          disablePadding: false,
          label: "Payment Method",
        },
      ];
    }
  };

  return (
    <TableHead style={{ backgroundColor: "rgb(236, 241, 246)" }}>
      <TableRow>
        {headCells().map((headCell) => (
          <TableCell
            key={headCell.id + Math.random()}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: "white",

          borderBottom: "1px solid #e8e8e8",
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const startDate = () => {
  var oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  return oneYearAgo;
};

const EnhancedTableToolbar = (props) => {
  const [selectedStartDate, setSelectedStartDate] = React.useState(startDate());
  const [selectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const [paymentId, setPaymentId] = React.useState("");
  const { getPayments } = React.useContext(HistoryContext);
  const authState = React.useContext(AuthContext);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  const classes = useToolbarStyles();
  const { numSelected } = props;

  const handleStartDateChange = (date) => {
    if (isNaN(date)) {
      setSelectedStartDate(date);
      props.setPage(0);
    } else {
      setSelectedStartDate(date);
      getPayments({
        startDate: date,
        endDate: selectedEndDate,
        customerID: authState.state.customerID,
        merchantID: authState.state.merchantID,
      });
      props.setPage(0);
    }
  };

  const handleEndDateChange = (date) => {
    if (date) {
      if (isNaN(date)) {
        setSelectedEndDate(date);
      } else {
        setSelectedEndDate(date);
        getPayments({
          startDate: selectedStartDate,
          endDate: date,
          customerID: authState.state.customerID,
          merchantID: authState.state.merchantID,
        });
        props.setPage(0);
      }
    } else {
      setSelectedEndDate(date);
      props.setPage(0);
    }
  };

  const handleChangeId = (event) => {
    setPaymentId(event.target.value);
    props.setPage(0);
  };

  const xLang = (string) => {
		return string
	}

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
      style={{
        display: "flex",
        flexDirection: isTabletOrMobile ? "column" : "row",
        paddingBottom: 15,
        justifyContent: "flex-end",
      }}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="start-date"
          label={xLang("Start Date")}
          format="MM/dd/yyyy"
          maxDate={new Date()}
          maxDateMessage={"Start date can't be after today"}
          value={selectedStartDate}
          onChange={handleStartDateChange}
          inputVariant="outlined"
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
          inputProps={{
            style: { borderColor: "green" },
          }}
          style={{ marginRight: 15 }}
        />
        <KeyboardDatePicker
          margin="normal"
          id="end-date"
          label={xLang("End Date")}
          maxDate={new Date()}
          maxDateMessage={"Start date can't be after today"}
          minDate={selectedStartDate}
          format="MM/dd/yyyy"
          value={selectedEndDate}
          onChange={handleEndDateChange}
          inputVariant="outlined"
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
          style={{ marginRight: 15 }}
        />
        <FormControl variant="outlined" style={{ marginTop: 7 }}>
          <InputLabel htmlFor="outlined-adornment-password">
          <x-lang>Search by id</x-lang>
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            style={{ width: 251 }}
            type={"text"}
            value={paymentId}
            label={xLang("Search by id")}
            onChange={(e) => handleChangeId(e)}
            onKeyUp={(e) => {
              if (e.keyCode === 13) {
                getPayments({
                  startDate: selectedStartDate,
                  endDate: selectedEndDate,
                  paymentId: paymentId,
                  customerID: authState.state.customerID,
                  merchantID: authState.state.merchantID,
                });
              }
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() =>
                    getPayments({
                      startDate: selectedStartDate,
                      endDate: selectedEndDate,
                      paymentId: paymentId,
                      customerID: authState.state.customerID,
                      merchantID: authState.state.merchantID,
                    })
                  }
                  edge="end"
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </MuiPickersUtilsProvider>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: 25,
    paddingTop: 10,
    boxSizing: "border-box",
    border: "1px solid #e3e6e7",
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable(props) {
  const classes = useStyles();
  const [openInvoiceModal, setOpenModal] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);

  const [dense] = React.useState(false);
  let { op } = useParams();

  const [rows, setRows] = React.useState([]);
  const [paymentTotal, setPaymentTotal] = React.useState(0.0);

  const { state, getPayments } = React.useContext(HistoryContext);
  const authState = React.useContext(AuthContext);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  // return focus to the button when we transitioned from !open -> open

  useEffect(() => {
    getPayments({
      startDate: startDate(),
      endDate: new Date(),
      customerID: authState.state.customerID,
      merchantID: authState.state.merchantID,
    });
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n);
      setSelected(newSelecteds);
      setPaymentTotal(setTotal(newSelecteds));
      return;
    }
    setSelected([]);
    setPaymentTotal(0.0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const setTotal = (arr) => {
    let total = 0;

    arr.map((item) => {
      total += parseFloat(item.due);
      return null;
    });

    return total.toFixed(2);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, state.payments.length - page * rowsPerPage);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: isTabletOrMobile ? "column" : "row",
        marginTop: isTabletOrMobile ? 15 : 0,
      }}
    >
      <div
        style={{
          width: "100%",
          boxSizing: "border-box",
          paddingTop: isTabletOrMobile ? 0 : 40,
          paddingLeft: isTabletOrMobile ? 15 : 0,
          paddingRight: isTabletOrMobile ? 15 : 0,
        }}
      >
        <Paper className={classes.paper} elevation={0}>
          <EnhancedTableToolbar
            numSelected={selected.length}
            paymentTotal={paymentTotal}
            setPage={setPage}
          />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {stableSort(state.payments, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <MyTableRow
                        row={row}
                        selected={selected}
                        setSelected={setSelected}
                        setTotal={setTotal}
                        index={index}
                        setPaymentTotal={setPaymentTotal}
                        openInvoiceModal={openInvoiceModal}
                        handleOpenModal={handleOpenModal}
                        handleCloseModal={handleCloseModal}
                        key={Math.random()}
                      />
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={state.payments.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          {/*<div style={{ width: '100%', textAlign: 'center', paddingTop: 25 }}>
						<a href={'/invoices'} style={{ color: '#1D9ADD' }}>
							Click here to see archived invoices
						</a>
								</div>*/}
        </Paper>
      </div>
      {isTabletOrMobile && authState.state.isFullAccount ? (
        <Paper
          style={{
            width: "100%",
            position: "fixed",
            bottom: 0,
            height: 70,
          }}
          elevation={5}
        ></Paper>
      ) : null}
      <Modal
        open={openInvoiceModal}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
        }}
      >
        <Paper
          elevation={3}
          style={{
            height: 800,
            width: 800,
            background: "white",
            outline: "none",
            borderRadius: 5,
            position: "relative",
          }}
        >
          <IconButton
            style={{ position: "absolute", top: 15, right: 15 }}
            onClick={handleCloseModal}
          >
            <CancelIcon />
          </IconButton>
        </Paper>
      </Modal>
    </div>
  );
}
